import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import VoucherPartnerDashboardScreen from 'features/Agency/screens/AgencyDashboard/screens/VoucherPartnerDashboardScreen';

function VoucherPartnerDashboard(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route path="" element={<VoucherPartnerDashboardScreen />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default VoucherPartnerDashboard;
